module.exports = __webpack_public_path__ + "static/img/inn6.6848938.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashu/inn6.jpg
// module id = jJLT
// module chunks = 1